import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary, ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CardComposerLabelsPopoverProps } from './CardComposerLabelsPopover';

export const LazyCardComposerLabelsPopover: FunctionComponent<CardComposerLabelsPopoverProps> = (
  props,
) => {
  const CardComposerLabelsPopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-composer-labels-popover" */ './CardComposerLabelsPopover'
      ),
    { namedImport: 'CardComposerLabelsPopover' },
  );
  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-workflowers', feature: 'Labels Popover' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <CardComposerLabelsPopover {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
